import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { MatDialog } from '@angular/material/dialog';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { CurrentUser } from '../../core/models/auth.model';
import { ChangePasswordDialogComponent } from '../../shared/components/change-password-dialog/change-password-dialog.component';

interface NavItem {
  label: string;
  icon: string;
  route: string;
  roles?: string[];
}

@Component({
  selector: 'app-main-layout',
  standalone: false,
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent implements OnInit {
  @ViewChild('drawer') drawer!: MatSidenav;

  isMobile = false;
  currentUser: CurrentUser | null = null;
  sidenavMode: 'side' | 'over' = 'side';
  sidenavOpened = true;

  navItems: NavItem[] = [
    { label: 'Dashboard', icon: 'dashboard', route: '/dashboard' },
    { label: 'Gate Passes', icon: 'description', route: '/gate-passes' },
    { label: 'Approvals', icon: 'approval', route: '/approvals', roles: ['ADMIN', 'DEPARTMENT_MANAGER'] },
    { label: 'Security Gate', icon: 'security', route: '/security', roles: ['ADMIN', 'SECURITY_OFFICER'] },
    { label: 'Stakeholders', icon: 'people', route: '/stakeholders', roles: ['ADMIN', 'STORE_OFFICER'] },
    { label: 'Users', icon: 'manage_accounts', route: '/users', roles: ['ADMIN'] },
    { label: 'Reports', icon: 'bar_chart', route: '/reports', roles: ['ADMIN', 'VIEWER', 'DEPARTMENT_MANAGER'] },
  ];

  constructor(
    private breakpointObserver: BreakpointObserver,
    private authService: AuthService,
    private router: Router,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.currentUser = this.authService.getCurrentUser();

    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((result) => {
      this.isMobile = result.matches;
      this.sidenavMode = result.matches ? 'over' : 'side';
      this.sidenavOpened = !result.matches;
    });
  }

  get visibleNavItems(): NavItem[] {
    return this.navItems.filter((item) => {
      if (!item.roles) return true;
      return item.roles.some((r) => this.authService.hasRole(r));
    });
  }

  get userDisplayName(): string {
    if (!this.currentUser) return 'User';
    return `${this.currentUser.firstName} ${this.currentUser.lastName}`;
  }

  get userInitials(): string {
    if (!this.currentUser) return 'U';
    return `${this.currentUser.firstName[0]}${this.currentUser.lastName[0]}`.toUpperCase();
  }

  toggleDrawer(): void {
    this.drawer.toggle();
  }

  openChangePassword(): void {
    this.dialog.open(ChangePasswordDialogComponent, { width: '400px', maxWidth: '95vw' });
  }

  logout(): void {
    this.authService.logout();
  }
}
